//
// CrosstabElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElement";
import "./crosstab/CrosstabLayout";
import "./crosstab/CrosstabReplicate";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "./table/TableColumnSizing";
import "./crosstab/CrosstabLabel";
import "./crosstab/CrosstabAxis";
import "./crosstab/CrosstabSummary";
import "./RowNumbers";
import "./crosstab/CrosstabMissingValueLabel";

var CrosstabElement = createModule("BIRD::CrosstabElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::VisualElement"], EventDispatcher, [
    ,
    {
        layout: 4,
        summary: 1,
        missingValueLabel: 4,
        replicate: 4,
        cellSpacing: 1,
        measureSizing: 4,
        rowNumbers: 1,
        axes: [1],
        cellPadding: 1,
        labels: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CrosstabElement;
